import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    BrowserRouter as Router,
    Switch,
    useHistory,
    useLocation
} from 'react-router-dom';
import Main from '@modules/main/Main';
import Login from '@modules/login/Login';
import ForgetPassword from '@modules/forgot-password/ForgotPassword';
import RecoverPassword from '@modules/recover-password/RecoverPassword';
import PrivacyPolicy from '@modules/privacy-policy/PrivacyPolicy';
import jwt_decode from 'jwt-decode';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import { URI_INTERNAL } from './utils/pathLocations';
import {
    REFRESH_TOKEN_KEY,
    refreshingPromise,
    TOKEN_KEY
} from '../src/utils/define';
import { logoutUser, refreshTokenFunc } from '@store/reducers/auth';
import './App.scss';
import { checkExpToken } from '@app/utils/helper';
import { getMenuAction } from '@app/store/reducers/menuItem';
import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { persistor } from '@app/store/store';
import Callback from '@app/modules/login/Callback';
import { userManager } from '@app/utils/oidc';
import LoginSSO from '@app/modules/login/LoginSSO';
import { getAccountAuthInfoByIdAccountAction, getAccountInfoByIdAccountAction } from '@app/store/reducers/account';
import { loginSuccess } from '@store/reducers/auth';
import { isTokenValid } from '@app/utils/helper';
import { EXPIRY_KEY } from './utils/define';

const App = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const isLoggedIn = useSelector(s => s.auth.isLoggedIn);

    // 1. Khôi phục session và Menu khi reload trang (F5)
    useEffect(() => {
        const initSession = async () => {
            const valid = await isTokenValid();
            if (valid) {
                // Đồng bộ trạng thái đăng nhập vào Redux
                dispatch(loginSuccess({ expiresAt: localStorage.getItem(EXPIRY_KEY) }));

                // Tải lại Menu (giúp thanh navigate không bị mất)
                dispatch(apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 }));
            }
        };
        initSession();
    }, [dispatch]);

    // 2. Tải lại thông tin khi trạng thái đăng nhập thay đổi
    useEffect(async () => {
        if (isLoggedIn) {
            const user = await userManager.getUser();
            if (user?.profile?.sub) {
                dispatch(getAccountAuthInfoByIdAccountAction(user.profile.sub));
                dispatch(getAccountInfoByIdAccountAction(user.profile.sub));
            }
        };
    }, [dispatch, isLoggedIn]);

    // useEffect(() => {
    //     if (!isLoggedIn) return;

    //     const onFocus = async () => {
    //         try {
    //             await dispatch(
    //                 apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
    //             ).unwrap();
    //         } catch {
    //             dispatch(logoutUser());
    //         }
    //     };
    //     window.addEventListener('focus', onFocus);
    //     return () => {
    //         window.removeEventListener('focus', onFocus);
    //     };
    // }, [dispatch, isLoggedIn]);

    // const token = localStorage.getItem(TOKEN_KEY);
    // const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    // const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    // if (token && refreshToken) {
    //     let decodedToken = jwt_decode(token);
    //     let currentDate = new Date();
    //     // JWT exp is in seconds
    //     // if (decodedToken.exp * 1000 < currentDate.getTime()) {
    //     //     dispatch(logoutUser());
    //     //     history.push('/login');
    //     // } else {
    //     //     console.log("Token còn hạn")
    //     // }

    //     if (decodedToken.exp * 1000 < currentDate.getTime()) {
    //         // dispatch(logoutUser());
    //         var model = {
    //             token: token,
    //             refreshToken: refreshToken
    //         }
    //         dispatch(refreshTokenFunc(model));
    //         // history.push('/login');
    //     } else {
    //         console.log("Token còn hạn")
    //     }

    // }

    // const permStatus = useSelector((state) => state.apiRoleMapping.status);
    // const mappings = useSelector(
    //     (state) => state.apiRoleMapping.listApiRoleMapping
    // );
    // const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);

    // useEffect(() => {
    //     if (isLoggedIn && mappings.length === 0) {
    //         dispatch(
    //             apiRoleMappingPagingAction({PageIndex: 1, PageSize: 10000})
    //         );
    //     }
    // }, [dispatch, isLoggedIn, mappings.length]);

    // useEffect(() => {
    //     let isMounted = true;

    //     async function init() {
    //         // 1) Get the current user (will be null if not signed in or if tokens expired)
    //         const user = await userManager.getUser();

    //         // 2) If we have a valid user and mappings not yet loaded, dispatch
    //         if (isMounted && user && mappings.length === 0) {
    //             dispatch(
    //                 apiRoleMappingPagingAction({
    //                     PageIndex: 1,
    //                     PageSize: 10000
    //                 })
    //             );
    //         }
    //     }

    //     init();

    //     // cleanup flag in case component unmounts
    //     return () => {
    //         isMounted = false;
    //     };
    // }, [dispatch, mappings]);

    return (
        <Switch>
            <PublicRoute exact path={URI_INTERNAL.LOGIN_PATH}>
                <Login />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.LOGIN_SSO_PATH}>
                <LoginSSO />{' '}
                {/* your <LoginSSO> that calls userManager.signinRedirect() */}
            </PublicRoute>
            <PublicRoute exact path="/callback">
                <Callback />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.FORGOT_PASSWORD_PATH}>
                <ForgetPassword />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.RECOVER_PASSWORD_PATH}>
                <RecoverPassword />
            </PublicRoute>
            <PublicRoute exact path="/privacy-policy">
                <PrivacyPolicy />
            </PublicRoute>
            {/* <PublicRoute exact path="/callback">
                <h1>Callback</h1>
            </PublicRoute> */}
            <PrivateRoute path="/">
                <Main />
            </PrivateRoute>
        </Switch>
    );
};

export default App;
